module.exports = __webpack_public_path__ + "bbeff14cb7441e8012729fd7087df360.woff2";


//////////////////
// WEBPACK FOOTER
// ./markup/fonts/roboto/roboto-regular.woff2
// module id = 1065
// module chunks = 0